import React from "react";
import { useNavigate } from "react-router-dom";

const BackLink = () => {
	const navigate = useNavigate();

	const handleBack = (e) => {
		e.preventDefault();
		if (window.history.length > 1) {
			navigate(-1);
		} else {
			window.location.href = "/";
		}
	};

	return (
		<a href="#" onClick={handleBack} className={"back-previous"}>
			<i className="fas fa-arrow-circle-left back-icon"></i>
		</a>
	);
};

export default BackLink;
